<div class="video-container">
    <video
        #myVideo
        (click)="togglePlayPause()"
        [src]="sourceUrl()"
        preload="metadata"
        (timeupdate)="onTimeUpdate()"
        [poster]="thumbnail_url()"
        (loadedmetadata)="onLoadedMetadata()"
        type="video/mp4"
        playsinline
        (loadeddata)="onLoad()"
        (error)="onError()"
        autoplay
    ></video>
    <div class="custom-controls">
        <!-- play button -->
        <div class="controls" data-on="main" (click)="togglePlayPause()">
            <wb-icon [name]="getPlayButtonIconImage()"></wb-icon>
        </div>
        <!-- play bar -->
        <div
            class="progress-container"
            (mousedown)="onSeekStart($event)"
            (mousemove)="onSeekMove($event)"
            (mouseup)="onSeekEnd($event)"
            (mouseleave)="onSeekEnd($event)"
        >
            <!-- base gray bar is background -->
            <div class="buffered-bar" [style.width.%]="bufferedPercent"></div>
            <div class="played-bar" [style.width.%]="playedPercent"></div>
            <div class="thumb" [style.left.%]="playedPercent"></div>
        </div>
        <!-- timestamp -->
        <span class="controls">{{ formatTime(currentTime) }} </span>
        <!-- volume button -->
        <div class="controls" data-on="main" (click)="toggleMute()">
            <wb-icon [name]="getMuteButtonIconImage()"></wb-icon>
        </div>
    </div>
</div>
